import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import './BuyBookPage.css';
import config from '../functions/config';

function BuyBookPage() {
  const [book, setBook] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [address, setAddress] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [userName, setUserName] = useState('');
  const [totalPrice, setTotalPrice] = useState(0);
  const [status, setStatus] = useState('Pending');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { bookId } = useParams();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [showAddressError, setShowAddressError] = useState(false);
  const [showPhoneError, setShowPhoneError] = useState(false);
  
  useEffect(() => {
    // Fetch book details
    axios.get(`${config.BASE_URL}/api/books/${bookId}/`)
      .then(response => {
        setBook(response.data);
        setTotalPrice((response.data.price * quantity).toFixed(2));  // Set initial total price
        setLoading(false);
      })
      .catch(error => {
        setError('Error fetching book details');
        setLoading(false);
      });

    // Get user details from session
    const sessionId = Cookies.get('sessionid');
    if (sessionId) {
      getUserDetails(sessionId);
    }
  }, [bookId, quantity]);

  const getUserDetails = async (sessionId) => {
    try {
        const response = await fetch(`${config.BASE_URL}/api/details/`, {

        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-Session-ID": sessionId,
        },
        credentials: "include",
      });

      if (response.ok) {
        const userData = await response.json();
        setUserName(userData.username);
      } else {
        const errorData = await response.json();
        setError(errorData.error || "Error fetching user details.");
      }
    } catch {
      setError("Failed to fetch user details.");
    }
  };

  const handleBuy = () => {
    if (quantity > book.stock) {
      alert('Quantity exceeds available stock');
      return;
    }

    const purchaseData = {
      book: book.id,
      quantity: quantity,
      address: address,
      phone_number: phoneNumber,
      total_price: totalPrice,
      status: status,
      user_name: Cookies.get('sessionid'),
    };
    console.log(`${config.BASE_URL}/api/purchase/`);

    axios.post(`${config.BASE_URL}/api/purchase/`, purchaseData)
    .then(response => {
        alert(`You bought "${book.title}"!`);
        navigate('/success');
      })
      .catch(error => {
        alert('Error processing purchase');
      });
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;
  if (!book) return <div>Book not found</div>;

  return (
    <div className="pt-5">
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
        <div className="container-fluid">
          <a className="navbar-brand" href="/">Library Management</a>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
          <li className="nav-item">
                <a className="nav-link" href="/success">
                   Books
                </a>
              </li>
            <ul className="navbar-nav ms-auto">
              <li className="nav-item"><a className="nav-link" href="/userhome">Home</a></li>
              <li className="nav-item"><a className="nav-link" href="/profile">Profile</a></li>
              <li className="nav-item">
            <a className="nav-link" href="/rentalhistory">Rented Books</a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="/purchasehistory">Purchase History</a>
          </li>             
           <li className="nav-item"><a href="/login" className="btn btn-danger">Logout</a></li>
            </ul>
          </div>
        </div>
      </nav>

      <div className="buy-book-page container pt-5 mt-5">
        <h2>{book.title}</h2>
        <p><strong>Author:</strong> {book.author}</p>
        <p><strong>Publisher:</strong> {book.publisher}</p>
        <p><strong>Price (per copy):</strong> ${book.price}</p>

  {/* Quantity Selection */}
<div className="mb-3 mt-5">
  <label className="form-label">Quantity (Max: {book.stock}):</label>
  <div className="d-flex align-items-center">
    <button
      className="btn btn-outline-primary"
      onClick={() => setQuantity(prev => Math.max(1, prev - 1))}
      style={{
        flex: "1 1 0", // Allow button to grow and shrink equally, starting from 0 basis
        height: "48px",
        fontSize: "1.5rem",
      }}
    >
      -
    </button>
    <input
      type="number"
      className="form-control text-center"
      value={quantity}
      min="1"
      max={book.stock}
      onChange={(e) => setQuantity(e.target.value)}
      style={{
        flex: "1 1 0", // Allow input to grow and shrink equally, starting from 0 basis
        height: "48px",
        fontSize: "1.5rem",
      }}
    />
    <button
      className="btn btn-outline-primary"
      onClick={() => setQuantity(prev => Math.min(book.stock, prev + 1))}
      style={{
        flex: "1 1 0", // Allow button to grow and shrink equally, starting from 0 basis
        height: "48px",
        fontSize: "1.5rem",
      }}
    >
      +
    </button>
  </div>
</div>



        
{/* Address Input */}
<div className="mb-3">
  <label>Address:</label>
  <textarea
    className="form-control"
    value={address}
    onChange={(e) => {
      setAddress(e.target.value);
      if (e.target.value) setShowAddressError(false); // Hide error when valid
    }}
    placeholder="Enter your shipping address"
    required
  />
  {showAddressError && !address && <small className="text-danger">Address is required.</small>}
</div>

{/* Phone Number Input */}
<div className="mb-3">
  <label>Phone Number:</label>
  <input
    type="text"
    className="form-control"
    value={phoneNumber}
    onChange={(e) => {
      const inputValue = e.target.value;
      if (/^\d*$/.test(inputValue)) {
        setPhoneNumber(inputValue);
        if (inputValue.length === 10 && inputValue >= "6000000000" && inputValue <= "9999999999") {
          setShowPhoneError(false); // Hide error when valid
        }
      }
    }}
    placeholder="Enter your phone number"
    required
    maxLength="10"
  />
  {showPhoneError && phoneNumber.length !== 10 && (
    <small className="text-danger">Enter a Valid Number.</small>
  )}
  {showPhoneError &&
    phoneNumber.length === 10 &&
    (phoneNumber < "6000000000" || phoneNumber > "9999999999") && (
      <small className="text-danger">Enter a valid  number.</small>
    )}
</div>


        {/* Total Price */}
        <div className="mb-3">
          <label>Total Price:</label>
          <input
            type="text"
            className="form-control"
            value={totalPrice}
            readOnly
          />
        </div>

        {/* Status */}
        <div className="mb-3">
          <label>Status:</label>
          <input
            type="text"
            className="form-control"
            value={status}
            readOnly
          />
        </div>
        <button
  className="btn btn-primary"
  onClick={() => {
    let isValid = true;

    if (!address) {
      setShowAddressError(true);
      isValid = false;
    }
    if (phoneNumber.length !== 10 || phoneNumber < "6000000000" || phoneNumber > "9999999999") {
      setShowPhoneError(true);
      isValid = false;
    }

    if (isValid) {
      setShowModal(true);
    }
  }}
>
  Buy
</button>


   {/* Payment Modal */}
   {showModal && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Choose Payment Method</h5>
              </div>
              <div className="modal-body">
              <div className="modal-body text-center">
  <button className="btn btn-light w-100 mb-2" onClick={() => { setShowModal(false); handleBuy(); }}>
    <img src="https://th.bing.com/th/id/OIP.dxJzE9-qkfues0WYQrtyEwHaEu?rs=1&pid=ImgDetMain" alt="Card Payment" width="100" />
  </button>
  <button className="btn btn-light w-100 mb-2" onClick={() => { setShowModal(false); handleBuy(); }}>
    <img src="https://static.vecteezy.com/system/resources/previews/017/221/776/non_2x/google-pay-logo-transparent-free-png.png" alt="Google Pay" width="100" />
  </button>
  <button className="btn btn-light w-100" onClick={() => { setShowModal(false); handleBuy(); }}>
    <img src="https://wallpapercave.com/wp/wp9684670.jpg" alt="Bank Transfer" width="100" />
  </button>
</div>

                <button  className=" btn btn-primary  w-100" onClick={() => setShowModal(false)}>Back</button>

              </div>
            </div>
          </div>
        </div>
      )}      </div>
    </div>
  );
}

export default BuyBookPage;
